import { ActionType } from '../../types/action';

const listPermission = {
  resource: 'user-group',
  action: ActionType.READ,
};
const createPermission = {
  resource: 'user-group',
  action: ActionType.CREATE,
};
const updatePermission = {
  resource: 'user-group',
  action: ActionType.UPDATE,
};
const updateDefaultPermission = {
  resource: 'default-user-group',
  action: ActionType.UPDATE,
};
const deletePermission = {
  resource: 'user-group',
  action: ActionType.UPDATE,
};

export const UserGroup = {
  list: listPermission,
  create: createPermission,
  update: updatePermission,
  updateDefault: updateDefaultPermission,
  delete: deletePermission,
};
